export default __webpack_public_path__ + "static/media/icon_social-instagram.6dc74713.svg";